//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/NXObject.js";
let d=[[],[[["dataObject","colIndex"],"SetContentPlaceholderDataAt",{},2,0],[[],"CreatePlaceholderData",{R_:{dataObject:"AME.ReportPlaceHolderData"}},0,0],[["colIndex"],"ResetContentPlaceholderDataAt",{},1,0],[["allSelectedColumnsOfTable"],"RemoveInputPlaceholderdata",{},1,0],[[],"CreateHeaderPlaceholderData",{R_:{dataObject:"AME.ReportHeaderPlaceHolderDataNode"}},0,0],[["colIndex","rowIndex"],"DeleteHeaderPlaceholderData",{},2,0],[["dataObject","counter"],"SetHeaderPlaceholderDataAt",{},2,0],[["dataObject","colIndex","rowIndex"],"SetHeaderPlaceholderCellRefAt",{},3,0],[["currentTxt","colIndex","rowIndex","isInHeader","textDir"],"UpdatePlaceholdersAndTextRotation",{},5,0]],[]];
SPLM.AME.ReportTemplate = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ReportTemplate";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;